module.exports = __webpack_public_path__ + "img/cf6b1a10-d684-11e8-87b4-351ed2ed509b-image.c4ff29fa.jpg";